import base from './base';

const primaryColor = '#0090d2';
const primary = '#0090d2';
const hover = '#f4c29a';
const errorColor = '#d71f28';

const hum6 = base({primaryColor, primary, hover, errorColor, base});
hum6.h1FontFamily = '"flood-std", sans-serif';
hum6.h3FontFamily = '"flood-std", sans-serif';
hum6.paymentButton.fontFamily = '"flood-std", sans-serif';
hum6.teaser.fontFamily = '"flood-std", sans-serif';
hum6.title.fontSize = '17px';
hum6.marginBottom = '10px';
hum6.mandateText = {
  fontSize: '12px',
  color: 'rgb(153, 153, 153)',
  fontStyle: 'italic'
};
hum6.formLayout = {...hum6.formLayout, gap: '10px'};
hum6.title.showInBody = false;
hum6.title.color = '#fff';
hum6.title.backgroundColor = primary;
hum6.title.height = '65px';
hum6.progressBar.height = '65px';
hum6.progressBar.useProgressTabs = false;
hum6.progressBar.step1of2 = undefined;
hum6.progressBar.step2of2 = undefined;

export default hum6;
